/*
 * @Autor: Baowang
 * @Date: 2024-11-07 09:13:28
 * @pageName: 
 * @LastEditTime: 2024-11-07 13:56:22
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/rem.js'; //vue自适应配置文件
import './utils/css/base.css'//页面样式初始化
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import * as echarts from 'echarts';
import 'echarts-gl';
Vue.prototype.$echarts = echarts //可以全局使用 不用每次使用需要在页面导入
// 引入请求方式
import request from './utils/request'
Vue.prototype.$api = request
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
